
import axios from 'axios';
import * as Constants from "../common/constants";
import { ActiveIngredientAdminModel } from "../models/activeIngredient/activeIngredientAdminModel";
import * as HelperFunctions from '../common/functions/helperFunctions';
import { ActiveIngredientFilterSettingsModel } from "../models/activeIngredient/activeIngredientFilterSettingsModel";
import AuthService from './authService';

class ActiveIngredientService {
	authService = new AuthService();

	constructor() {
		axios.defaults.baseURL = `${Constants.apiUrl}/`;
		axios.defaults.headers = {
			"Content-Type": "application/json; charset=utf-8",
			Authorization: `Bearer ${this.authService.getToken()}`,
			Pragma: 'no-cache'
		}
	}

	getAllActiveIngredients(from: number, numberOfRows: number, settings: ActiveIngredientFilterSettingsModel) {
		return axios({
			url: `adminActiveIngredient/getAll/${from}/${numberOfRows}`,
			method: 'post', headers: {
				"Content-Type": "application/json; charset=utf-8"
			},
			data: JSON.stringify(settings)
		})
			.then(res => res.data.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	getActiveIngredient(id: number) {
		return axios({
			url: `adminActiveIngredient/getById/${id}`,
			method: 'get'
		})
			.then(res => res.data.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	addActiveIngredient(activeIngredient: ActiveIngredientAdminModel) {
		return axios({
			url: `adminActiveIngredient/createActiveIngredient`,
			method: 'post',
			headers: {
				"Content-Type": "application/json; charset=utf-8"
			},
			data: JSON.stringify(activeIngredient)
		})
			.then(res => res.data.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	editActiveIngredient(id: number, activeIngredient: ActiveIngredientAdminModel) {
		return axios({
			url: `adminActiveIngredient/updateActiveIngredient/${id}`,
			method: 'put',
			headers: {
				"Content-Type": "application/json; charset=utf-8"
			},
			data: JSON.stringify(activeIngredient)
		})
			.then(res => res.data.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	deleteActiveIngredient(id: number) {
		return axios({
			url: `adminActiveIngredient/deleteActiveIngredient/${id}`,
			method: 'delete'
		})
			.then(res => res.data.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	getDropdownInteraction(id: number) {
		return axios({
			url: `adminActiveIngredient/getDropdownInteraction/${id}`,
			method: 'get', headers: {
				"Content-Type": "application/json; charset=utf-8"
			}
		})
			.then(res => res.data.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	getDropdownFrequencyOfReaction() {
		return axios({
			url: `adminActiveIngredient/getDropdownFrequencies`,
			method: 'get', headers: {
				"Content-Type": "application/json; charset=utf-8"
			}
		})
			.then(res => res.data.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	getDropdownAnatomicalSystem() {
		return axios({
			url: `adminAnatomicalSystem/getDropdownList`,
			method: 'get', headers: {
				"Content-Type": "application/json; charset=utf-8"
			}
		})
			.then(res => res.data.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}
}

export default ActiveIngredientService;
